import React from 'react';
import CampaignOverviewContainer from '../../../Components/Dashboards/BrandCampaign/CampaignOverviewContainer';

export default function CampaignDetailsPage() {
    return <CampaignOverviewContainer />;
}
